export const plans = [
  {
    id: "gratis",
    name: "Gratis",
    desc: "Para iglesias que quieren empezar sin compromiso.",
    price: 0,
    features: [
      "Hasta 75 miembros · 2 usuarios",
      "Deja de gestionar tu congregación en papel o en WhatsApp",
      "Ficha completa de cada miembro: datos personales e historial",
      "Importa tu directorio actual desde Excel sin esfuerzo",
      "Ningún nuevo creyente pierde el seguimiento ni queda sin responsable",
      "Tu agenda de eventos clara y accesible para todo el equipo",
      "Disponible desde el móvil, la tablet o el ordenador",
      { text: "Una formación incluida", tooltip: "Formaciones presenciales solo en Madrid" },
    ],
    highlight: false,
    prefix: "",
  },
  {
    name: "Esencial",
    desc: "Ideal para iglesias que empiezan a organizarse de forma seria.",
    features: [
      "Todo lo del plan Gratis, más:",
      "Hasta 300 miembros · 10 usuarios",
      "Cada ministerio con sus líderes y miembros definidos",
      "Sabe al instante quién sirve en cada área de la iglesia",
      "Organiza el liderazgo de cada departamento sin confusiones",
      "Asigna y mueve miembros entre ministerios con facilidad",
      "Deja de gestionar equipos por grupos de WhatsApp",
      "Controla quién está activo, inactivo o es visitante",
      "Filtra tu directorio por cualquier criterio en segundos",
      "Tu equipo de liderazgo trabajando en la misma herramienta",
      "Crece sin perder el orden",
      { text: "Tres formaciones incluidas", tooltip: "Formaciones presenciales solo en Madrid" },
    ],
    highlight: false,
    prefix: "",
  },
  {
    name: "Avanzado",
    desc: "Para congregaciones que quieren el máximo rendimiento.",
    features: [
      "Todo lo del plan Esencial, más:",
      "Hasta 1.000 miembros · 20 usuarios",
      "Comunícate con toda tu congregación con un solo correo",
      "Segmenta tus mensajes: por ministerio, estado o grupo",
      "10.000 correos al mes incluidos",
      "Plantillas listas: bienvenidas, eventos, devocionales y recordatorios",
      "Historial completo de cada comunicación enviada",
      "Ofrendas y diezmos registrados con claridad y sin errores",
      "Control de gastos e ingresos, área por área",
      "Presupuestos definidos para cada departamento o evento",
      "Nunca más desde tesorería preguntando dónde está el balance",
      "Documentos de la iglesia accesibles para todo el equipo",
      "1 GB de almacenamiento incluido, ampliable cuando lo necesites",
      "Métricas reales: crecimiento, integración y actividad",
      "Reportes claros para presentar en junta o liderazgo",
      "Para iglesias que necesitan gestionarlo todo desde un solo lugar",
      { text: "Formación personalizada", tooltip: "Formaciones presenciales solo en Madrid" },
    ],
    highlight: true,
    prefix: "",
  },
  {
    name: "Institucional",
    desc: "Incluye todo lo del plan Avanzado, además de:",
    features: [
      "Todo lo del plan Avanzado, más:",
      "Miembros y usuarios sin límite",
      "Almacenamiento ampliado según tus necesidades",
      "Estructura personalizada para la iglesia o red",
      "Formación inicial incluida para tu equipo de liderazgo",
      "Incorporación asistida, te ayudamos a configurarlo todo",
      "Soporte directo y prioritario con respuesta garantizada",
      { text: "Formación y acompañamiento a medida", tooltip: "Formaciones presenciales solo en Madrid" },
    ],
    highlight: false,
    prefix: "Desde ",
  },
];
